import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import { useTheme } from '@mui/material/styles';
import { getCdnUrl } from '../../../helpers';
import {
  STACK_CENTER,
  BOX_CENTER_IMAGE,
  STACK_START_COLUMN_DIRECTION,
} from '../../../constants/mui-components';
import {
  productSectionStack,
  imageContainer,
  imageStyles,
  contentStack,
  iconContainer,
  iconStyles,
  titleTypography,
  textTypography,
} from '../styles/product-section.styles';

function ProductSection({
  productData,
  flexDirection = 'row',
  stackProps = {},
}) {
  const theme = useTheme();
  return (
    <Stack
      className={STACK_CENTER}
      sx={productSectionStack(flexDirection, stackProps)}
    >
      <Box
        className={BOX_CENTER_IMAGE}
        sx={imageContainer}
      >
        <CardMedia
          component="img"
          image={getCdnUrl(productData.image)}
          alt="description_image"
          style={imageStyles}
        />
      </Box>
      <Stack
        className={STACK_START_COLUMN_DIRECTION}
        sx={contentStack}
      >
        <Box
          className={BOX_CENTER_IMAGE}
          sx={iconContainer}
        >
          <CardMedia
            component="img"
            image={getCdnUrl('/images/invoice_icon.png')}
            alt="invoice_icon"
            style={iconStyles}
          />
        </Box>
        <Typography variant="xlarge_2" sx={titleTypography(theme)}>
          {productData.title}
        </Typography>
        {typeof productData.text === 'string' ? (
          <Typography variant="medium_1" sx={textTypography(theme)}>
            {productData.text}
          </Typography>
        ) : (
          <ul style={{ margin: 0 }}>
            {productData.text.map((text) => (
              <Typography variant="medium_1" color={theme.palette.neutral.A500} fontWeight={500}>
                <li style={{ marginBottom: '0.5rem' }}>
                  {text}
                </li>
              </Typography>
            ))}
          </ul>
        )}
      </Stack>
    </Stack>
  );
}

ProductSection.propTypes = {
  flexDirection: PropTypes.string,
  productData: PropTypes.shape({
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  }).isRequired,
  stackProps: PropTypes.shape({}),
};

ProductSection.defaultProps = {
  flexDirection: 'row',
  stackProps: {},
};

export default ProductSection;
